var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-10"},[_c('v-card-title',[_c('h2',[_vm._v("Orders confirmations pendings")])]),_vm._v(" "),_c('OrderTable'),_vm._v(" "),_c('v-card-title',[_c('h2',[_vm._v("Sample request in preparation")])]),_vm._v(" "),_c('SampleOrderTable')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f5cd37e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/home/HomeComponent.vue
// module id = null
// module chunks = 